import { create, StateCreator } from "zustand";
import { createJSONStorage, persist, PersistOptions } from 'zustand/middleware';
import { IKioskList } from "../types/menu";
import { logger } from "../utils/logger";

type KioskStore = {
  openDiningOption: boolean;
  openCallName: boolean;
  openMyOrder: boolean;
  kioskOrderList: IKioskList;
  diningOption: number;
  setKioskOrderList: (value: IKioskList) => void;
  setDiningOption: (val: number) => void;
  setOpenDiningOption: (val: boolean) => void;
  setOpenCallName: (val: boolean) => void;
  setOpenMyOrder: (val: boolean) => void;
  resetKiosk: () => void;
};

type MyPersist = (
  config: StateCreator<KioskStore>,
  options: PersistOptions<KioskStore>
) => StateCreator<KioskStore>;

type State = {
  openDiningOption: boolean;
  openCallName: boolean;
  openMyOrder: boolean;
  kioskOrderList: IKioskList;
  diningOption: number;
};

const initialState: State = {
  openDiningOption: false,
  openCallName: false,
  openMyOrder: false,
  kioskOrderList: {} as IKioskList,
  diningOption: 1,
};

export const useKioskStore = create<KioskStore>(
  (persist as MyPersist)(
    (set, get): KioskStore => ({
      ...initialState,
      setKioskOrderList: (items: IKioskList) => {
        set({ kioskOrderList: items });
      },
      setDiningOption: (val: number) => {
        if (typeof val === 'number') {
          set({ diningOption: val });
        } else {
          logger.error('Invalid diningOption value:', val);
        }
      },
      setOpenDiningOption: (val: boolean) => {
        if (typeof val === 'boolean') {
          set({ openDiningOption: val });
        } else {
          logger.error('Invalid openDiningOption value:', val);
        }
      },
      setOpenCallName: (val: boolean) => {
        if (typeof val === 'boolean') {
          set({ openCallName: val });
        } else {
          console.error('Invalid openCallName value:', val);
        }
      },
      setOpenMyOrder: (val: boolean) => {
        if (typeof val === 'boolean') {
          set({ openMyOrder: val });
        } else {
          console.error('Invalid openMyOrder value:', val);
        }
      },
      resetKiosk: () => {
        set({ ...initialState });
        console.log('Kiosk state reset to initialState:', initialState);
      },
    }),
    {
      name: 'order',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
